import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock } from 'lucide-react';
import '../styles/global.css';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('citizen'); // Default role

  const handleLogin = (e) => {
    e.preventDefault();
    // In a real app, we would validate the password here
    login(role);
    navigate(role === 'admin' ? '/admin' : '/map');
  };

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      background: 'radial-gradient(circle at center, #1e293b 0%, #0f172a 100%)' 
    }}>
      <div className="glass-panel" style={{ padding: '40px', width: '400px', maxWidth: '90%' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>Welcome Back</h2>
          <p style={{ color: 'var(--text-muted)' }}>Secure access to RoadGuard AI</p>
        </div>

        {/* Role Toggle */}
        <div style={{ 
          display: 'flex', background: 'rgba(255,255,255,0.05)', 
          padding: '5px', borderRadius: '10px', marginBottom: '20px' 
        }}>
          <button 
            onClick={() => setRole('citizen')}
            style={{ 
              flex: 1, padding: '8px', borderRadius: '8px', border: 'none', cursor: 'pointer',
              background: role === 'citizen' ? 'var(--primary)' : 'transparent',
              color: role === 'citizen' ? 'white' : 'var(--text-muted)', fontWeight: '600', transition: '0.3s'
            }}
          >
            Citizen
          </button>
          <button 
            onClick={() => setRole('admin')}
            style={{ 
              flex: 1, padding: '8px', borderRadius: '8px', border: 'none', cursor: 'pointer',
              background: role === 'admin' ? 'var(--primary)' : 'transparent',
              color: role === 'admin' ? 'white' : 'var(--text-muted)', fontWeight: '600', transition: '0.3s'
            }}
          >
            Admin
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          
          {/* Email Input */}
          <div style={{ position: 'relative' }}>
            <Mail size={18} style={{ position: 'absolute', left: '12px', top: '14px', color: 'var(--text-muted)' }} />
            <input 
              type="email" 
              placeholder="Email Address" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ paddingLeft: '40px' }} 
              required
            />
          </div>

          {/* Password Input */}
          <div style={{ position: 'relative' }}>
            <Lock size={18} style={{ position: 'absolute', left: '12px', top: '14px', color: 'var(--text-muted)' }} />
            <input 
              type="password" 
              placeholder="Password" 
              style={{ paddingLeft: '40px' }} 
              required
            />
          </div>

          <button type="submit" className="btn-primary" style={{ marginTop: '10px' }}>
            {role === 'citizen' ? 'Login to Map' : 'Access Dashboard'}
          </button>

        </form>

        {/* Google Mock Button */}
        <div style={{ marginTop: '20px', borderTop: '1px solid var(--glass-border)', paddingTop: '20px' }}>
          <button onClick={() => handleLogin({ preventDefault: () => {} })} style={{
            width: '100%', padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
            background: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '500', color: '#333'
          }}>
            <img src="https://cdn-icons-png.flaticon.com/512/2991/2991148.png" width="20" alt="G" />
            Continue with Google
          </button>
        </div>

      </div>
    </div>
  );
};

export default Login;